import { Component } from "react";
import { ImageOff, RotateCw } from "lucide-react";

// Localized boundary for the image preview/detail view. Instead of white-screening the
// whole app, it renders a styled "Image unavailable" card with a working retry.
export class PreviewErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("PreviewErrorBoundary caught:", error, info);
  }

  reset = () => {
    this.setState({ hasError: false });
    this.props.onReset?.();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="preview-error-fallback" className="panel-card" style={{ padding: 28, textAlign: "center" }}>
        <ImageOff size={26} style={{ color: "var(--tmuted)", margin: "0 auto 12px" }} />
        <div className="font-display" style={{ fontSize: 15, fontWeight: 600, color: "var(--tprimary)", marginBottom: 6 }}>
          Image unavailable
        </div>
        <p className="font-body" style={{ fontSize: 12.5, color: "var(--tsecondary)", margin: "0 0 16px", lineHeight: 1.5 }}>
          This preview couldn't load — the image may have expired or failed to render.
        </p>
        <button data-testid="preview-error-regenerate" className="btn-primary font-mono" style={{ padding: "9px 16px", fontSize: 12 }} onClick={this.reset}>
          <RotateCw size={13} /> Regenerate
        </button>
      </div>
    );
  }
}
